var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10640_4157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5028 39.5614C47.4995 31.5647 47.4995 18.5994 39.5028 10.6027C31.506 2.60594 18.5408 2.60594 10.5441 10.6027C2.54733 18.5994 2.54733 31.5647 10.5441 39.5614C18.5408 47.5581 31.506 47.5581 39.5028 39.5614Z",
    fill: "#FE646F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0287 31.2613C24.5743 31.2613 24.1854 30.8735 24.1065 30.3402L21.7821 14.6624C21.4899 12.6879 22.7654 10.8779 24.4487 10.8779H25.6076C27.291 10.8779 28.5665 12.6879 28.2743 14.6624L25.9499 30.3402C25.8721 30.8735 25.4832 31.2613 25.0287 31.2613Z",
    fill: "#E6E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1554 37.1591C27.1554 35.988 26.1999 35.0325 25.0288 35.0325C23.8577 35.0325 22.9021 35.988 22.9021 37.1591C22.9021 38.3302 23.8577 39.2858 25.0288 39.2858C26.1999 39.2858 27.1554 38.3314 27.1554 37.1591Z",
    fill: "#E6E9ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10640_4157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.fa52f945e7893d662651a2c910bd2483.svg";
export { ForwardRef as ReactComponent };